var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingQiwaPersonal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3334 10.0003C18.3334 14.6027 14.6025 18.3337 10.0001 18.3337C5.39771 18.3337 1.66675 14.6027 1.66675 10.0003C1.66675 5.39795 5.39771 1.66699 10.0001 1.66699C14.6025 1.66699 18.3334 5.39795 18.3334 10.0003ZM12.0834 6.87533C12.0834 8.02592 11.1507 8.95866 10.0001 8.95866C8.84949 8.95866 7.91675 8.02592 7.91675 6.87533C7.91675 5.72473 8.84949 4.79199 10.0001 4.79199C11.1507 4.79199 12.0834 5.72473 12.0834 6.87533ZM10 11.042C7.8984 11.042 6.08752 12.2867 5.26439 14.0792C6.41053 15.4087 8.10701 16.2503 10.0001 16.2503C11.8931 16.2503 13.5895 15.4087 14.7357 14.0793C13.9125 12.2868 12.1016 11.042 10 11.042Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingQiwaPersonal);
export default __webpack_public_path__ + "static/media/onboarding-qiwa-personal.1cbffebae949ba9daeccfbcec4a46904.svg";
export { ForwardRef as ReactComponent };